import React from 'react'

import DetailStatusMobileHeader from '../../../components/DetailStatusMobileHeader'
import PaymentAttachmentsCard from '../../../components/details/attachments/PaymentAttachmentsCard'
import NoEffectiveVisitSummarySection from '../shared/NoEffectiveVisitSummarySection'

export default function NoEffectiveVisitDetailsMobile({
  activity,
  statusUI,
  summaryFields,
  fieldsToRender,
  paymentAttachments
}) {
  return (
    <div className="container-fluid px-0">
      <DetailStatusMobileHeader
        title="Detalles de visita:"
        statusUI={statusUI}
        fallbackStatus={activity?.status}
      />

      <NoEffectiveVisitSummarySection
        summaryFields={summaryFields}
        extraFields={fieldsToRender}
      />

      <PaymentAttachmentsCard
        images={paymentAttachments.images}
        files={paymentAttachments.files}
        title="ADJUNTO(S)"
        emptyDescription="Cuando esta visita tenga imágenes o archivos asociados, aparecerán aquí para su revisión."
      />
    </div>
  )
}
